import { render } from "./page-vision-mission.vue?vue&type=template&id=83e4a5c8&scoped=true"
import script from "./page-vision-mission.vue?vue&type=script&lang=js"
export * from "./page-vision-mission.vue?vue&type=script&lang=js"

import "./page-vision-mission.vue?vue&type=style&index=0&id=83e4a5c8&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83e4a5c8"]])

export default __exports__